import e, { css as t } from "styled-components";
import r from "../../utils/colors.js";
import { device as i } from "../../utils/device.js";
import { Button as n } from "../Button/Button.js";
const l = e.div`
  display: flex;
`, a = e.div`
  display: flex;
  flex-direction: column;
`, x = e.div`
  display: flex;
  flex-direction: column;

  button + button {
    margin: 24px 0 0 0;
  }

  @media ${i.isTabletAndAbove} {
    flex-direction: row-reverse;
    justify-content: flex-end;

    button + button {
      margin: 0 24px 0 0;
    }
  }
`, u = e(n)`
  @media ${i.isTabletAndAbove} {
    min-width: 200px;
  }
`, b = e.button`
  position: relative;
  height: 80px;
  width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid ${r.blueGrey};
  border-radius: 1px;
  cursor: pointer;
  background: none;
  user-select: none;

  ${(o) => o.$disabledStyle && t`
      background-color: ${r.darkGrey10};
      border: 1px solid ${r.darkGrey75};
      padding: 1px;
      span {
        color: #707070;
      }
    `}

  ${(o) => o.selected && t`
      border: 2px solid ${r.orange};
      span {
        color: ${r.orange};
      }
    `};

  &:first-child {
    margin-right: 20px;
  }

  &:active,
  &:focus {
    outline: none;
  }
`, m = e.div`
  position: absolute;
  width: 20px;
  top: -8px;
  right: -8px;
`, f = e.div`
  margin-bottom: ${(o) => `${o.space}px`};
`;
export {
  x as ButtonContainer,
  u as ButtonWrapper,
  m as CircleTickWrapper,
  a as FeedbackWrapper,
  l as IconsWrapper,
  f as Spacer,
  b as ThumbWrapper
};
